/* eslint-disable import/no-unresolved */
import { useEffect, useRef, useState } from 'react'
import { Icon } from 'assets/index'
import useStorage from 'hooks/useStorage'
import {
  FileInput,
  TextInput,
  Subtitle,
  Underlined,
  GreyInfo,
  Row,
  Column,
  Flag,
  ActionIcon,
  Ancor,
  FileImage,
  InputError,
} from './style'

interface StyleOptions {
  icon: string // icone de pdf ou imagem
  accept: string // tipos de arquivos a serem aceitos no input de arquivo
  label: string // Titulo do input (ex: Upload de PDF)
  info: string // Recomendacao de upload (ex: • Documento no formato PDF)
}

interface UploadProps {
  id?: string
  mandatory?: boolean // quando o input e obrigatorio
  options: StyleOptions
  ready?: boolean // para ficar na configuracao de border vermelha
  file?: any // Recebe o arquivo para consulta
  // link?: string // Link para o arquivo
  // onVisualize?: any
  disableInput?: boolean
  fileName?: string // caso o arquivo ja tenha titulo
  nameFilePlaceholder?: string // caso precise preencher titulo
  edit?: boolean
  download?: boolean
  visualize?: boolean
  flag?: string
  onChangeFile?: (_name: string, _file: File) => any // callback ao subir arquivo
  onClickCheck?: any // callback para icone de check
  onClickTrash?: any // callback para icone de lixo
  onClickRemoveFile?: any // callback para excluir file selecionado
  erro?: string
  onFocus?: () => void
  // name: string
  url?: string | undefined
  noDeleteFile?: boolean
}

const status: any = {
  PENDENT: 'Pendente',
  SIGNED: 'Assinado',
}

const UploadFile = (props: UploadProps) => {
  const textRef = useRef<HTMLInputElement>(null)
  const [fileName, setFileName] = useState<string | undefined>(props?.fileName)
  const [pdfLink, setPdfLink] = useState<string | undefined>(props?.url)
  const [file, setFile] = useState<any>(props?.file)
  const [user] = useStorage('User')
  // const [erro, setErro] = useState(props?.initialError)
  // const inputRef = useRef<any>(null)
  // const { fieldName, registerField, error } = useField(fileName)
  const { onChangeFile, onFocus } = props

  useEffect(() => {
    props?.file && setFile(props?.file)
  }, [props?.file])

  useEffect(() => {
    if (!file) return
    if (props?.download || props?.visualize) {
      if (props?.url) {
        return setPdfLink(props?.url)
      }
      if (props?.file) {
        setPdfLink(props?.file?.url)
        return
      }
      const url = URL.createObjectURL(file)
      setPdfLink(url)
    }
  }, [file])

  // useEffect(() => {
  //   registerField({
  //     name: fieldName,
  //     ref: inputRef,
  //     getValue: (ref) => {
  //       return ref.current.value
  //     },
  //     setValue: (ref, value) => {
  //       ref.current.value = value
  //     },
  //     clearValue: (ref) => {
  //       ref.current.value = ''
  //     },
  //   })
  // }, [fieldName, registerField])

  const handleChange = (e: any) => {
    setFile(e.target.files[0])
    onChangeFile && onChangeFile(fileName || '', e.target.files[0])
  }

  return (
    <Column id={props?.id}>
      <Row style={{ width: '100%' }}>
        <TextInput
          ref={textRef}
          type="text"
          placeholder={props?.nameFilePlaceholder}
          disabled={!props?.edit || file}
          defaultValue={fileName}
          onChange={(e) => {
            setFileName(e.target.value)
          }}
        />
        {props?.onClickCheck && (
          <ActionIcon
            alt="check-icon"
            src={Icon('check_circle.svg')}
            onClick={() => props?.onClickCheck(fileName)}
          />
        )}
        {props?.edit && !file && (
          <ActionIcon
            alt="edit-icon"
            src={Icon('edit.svg')}
            onClick={() => textRef.current?.focus()}
          />
        )}
        {props?.onClickTrash && (
          <ActionIcon
            alt="trash-icon"
            src={Icon('trash.svg')}
            onClick={() => props?.onClickTrash(fileName, props?.id)}
          />
        )}
        {props?.visualize && (
          <ActionIcon
            alt="doc-icon"
            src={Icon('doc.svg')}
            onClick={() => {
              window.open(pdfLink, '_blank')
            }}
          />
        )}
        {props?.download && (
          <a href={pdfLink} download={file?.name}>
            <ActionIcon
              alt="download-icon"
              src={Icon('login.svg')}
              style={{ transform: 'rotate(270deg)' }}
            />
          </a>
        )}
        {props?.flag && <Flag flag={props?.flag}>{status[props?.flag]}</Flag>}
      </Row>
      <Row style={{ marginTop: 16 }}>
        <Underlined>Selecione um arquivo</Underlined>
        <GreyInfo>{` ou arraste e solte aqui`}</GreyInfo>
      </Row>
      <Ancor>
        <FileInput
          error={props?.erro}
          htmlFor={fileName}
          filled={file}
          ready={props?.ready}
          mandatory={props?.mandatory}
        >
          <Row>
            <FileImage
              mandatory={props?.mandatory}
              filled={file}
              ready={props?.ready}
              alt="file-icon"
              src={Icon(props?.options.icon)}
              style={{ marginRight: 15 }}
            />
            <span id="upload-text">{file?.name || props?.options.label}</span>
            {!props?.file && (
              <input
                // ref={inputRef}
                disabled={props?.disableInput || user?.permission === 'READ'}
                type="file"
                className="hide-input"
                id={fileName}
                name={fileName}
                accept={props?.options.accept}
                onChange={handleChange}
                onFocus={onFocus}
              />
            )}
          </Row>
          {!file && (
            <FileImage
              mandatory={props?.mandatory}
              ready={props?.ready}
              alt="file-icon"
              src={Icon('cloud.svg')}
              style={{ right: 16 }}
            />
          )}
        </FileInput>
        {props?.erro && <InputError>{props?.erro}</InputError>}
        {file && !props?.disableInput && !props?.noDeleteFile && (
          <FileImage
            filled
            alt="file-icon"
            src={Icon('x_circle.svg')}
            style={{ right: 16, top: 12 }}
            onClick={() => {
              props?.onClickRemoveFile(fileName)
              setFile(null)
            }}
          />
        )}
      </Ancor>
      <Subtitle>Recomendações do upload:</Subtitle>
      <Column>
        <GreyInfo small>{props?.options.info}</GreyInfo>
        <GreyInfo small>• Tamanho máximo do arquivo: 10MB</GreyInfo>
      </Column>
    </Column>
  )
}

export default UploadFile
